import { memo } from 'react';
import { defaultLocale } from '@quno/onboarding/src/constants/locales';
import { Base } from '@quno/patient-journey/src/contentful/patient-journey/blocks/Base';
import { CodeCard } from '@quno/patient-journey/src/components/Card/Variants/CodeCard';
import { useTranslation } from '@quno/patient-journey/src/hooks/useTranslation';
import { localeMapper } from '@quno/onboarding/src/constants/locales';
import { getStringMultilocale } from '@quno/onboarding/src/generator/configs/componentMapper';
import type { CodeContainer } from '@quno/onboarding/src/generator/types/Models';
import type { FormLocales } from '@quno/patient-journey/src/constants/locales';

type CodeProps = CodeContainer & {
  locale: FormLocales;
};

const MemoizedCodeCard = memo(
  CodeCard,
  (prevProps, nextProps) => prevProps.embed === nextProps.embed,
);

export const Code = (props: CodeProps): JSX.Element => {
  const { attributes } = props ?? {};
  const { locale: pageLocale } = useTranslation(true);
  const locale = props.locale || localeMapper[pageLocale] || defaultLocale;
  const codeCards = attributes?.codeCards?.[defaultLocale];

  return (
    <Base {...props}>
      <>
        {codeCards?.map((codeCard) => {
          const embed = getStringMultilocale(
            codeCard?.attributes?.embed,
            locale,
          );
          return <MemoizedCodeCard key={codeCard.uuid} embed={embed} />;
        })}
      </>
    </Base>
  );
};
